import { ActionType, getType } from 'typesafe-actions';
import * as currentOrder from '../../actionCreators/currentOrder';
// import getMenu, { $getMenu } from '../../selectors/getMenu';

const initialState = null;

export default function (
  state: Menu | null = initialState,
  action: ActionType<typeof currentOrder>,
): Menu | null {
  switch (action.type) {
    case getType(currentOrder.setCachedMenu): {
      //   console.log({ action });
      const { value } = action.payload;
      return value == null ? initialState : value;
    }

    case getType(currentOrder.applyBufferData): {
      const { menu } = action.payload.value;
      return menu === undefined ? state : menu;
    }
    default:
      return state;
  }
}
